/**
 * Row-level validation. SPEC-0001 step 5.
 *
 * Rows are schema-validated and the user gets a per-row report of what failed
 * and why, not a single opaque error.
 */
import { parseMoneyToCents } from '@picklii/recon';
import { z } from 'zod';
/** Hours are decimal numbers; money is integer cents. ADR-0002. */
const hours = z.coerce.number().finite().min(0);
const isoDate = z.string().trim();
export const soldRowSchema = z.object({
    projectId: z.string().trim().min(1),
    clientName: z.string().trim().min(1),
    role: z.string().trim().min(1),
    soldHours: hours,
    /** Arrives as a decimal string and is converted on ingest. SPEC-0001. */
    rateCents: z
        .union([z.string(), z.number()])
        .transform((v, ctx) => {
        const cents = parseMoneyToCents(v);
        if (cents === null || cents < 0) {
            ctx.addIssue({ code: 'custom', message: 'not a valid rate' });
            return z.NEVER;
        }
        return cents;
    }),
    sowSignedDate: isoDate,
    /**
     * SPEC-0007. Optional, like `sowSignedDate` — empty string when the
     * customer's export doesn't carry it, never guessed from another field.
     */
    goLiveDate: isoDate,
    endDate: isoDate,
});
export const budgetRowSchema = z.object({
    projectId: z.string().trim().min(1),
    clientName: z.string().trim().min(1),
    role: z.string().trim().min(1),
    budgetedHours: hours,
    hoursConsumed: hours,
    lastUpdated: isoDate,
});
//# sourceMappingURL=rows.js.map